import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

/**
 * Opt out of the global loading overlay for a specific request, e.g.:
 *   http.get(url, { context: new HttpContext().set(SKIP_LOADING, true) })
 * Useful for background polling / health checks that shouldn't block the UI.
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

// Only "saving" requests show the overlay. Reads (GET) stay silent to avoid flicker.
const MUTATING_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const tracked =
    !req.context.get(SKIP_LOADING) && MUTATING_METHODS.has(req.method.toUpperCase());

  if (!tracked) {
    return next(req);
  }

  const loading = inject(LoadingService);
  loading.start();
  return next(req).pipe(finalize(() => loading.stop()));
};
